export const FUNDING_APP_HASH = {
  group: "#group",
  brand: "#brand",
};
